<template>
  <div class="brand-icon">
    <img :src="iconUrl" class="brand-icon__image" :alt="alt" @click="onClick" />
  </div>
</template>

<script>
export default {
  props: {
    iconUrl: {
      type: String,
      required: true
    },
    alt: {
      type: String,
      required: false,
      default: 'brand-icon'
    }
  },
  methods: {
    onClick() {
      this.$emit('click-image')
    }
  }
}
</script>
<style lang="scss" scoped>
.brand-icon {
  @extend %hover-common;
  width: 100%;
  height: 100%;
  max-width: 115px;
  min-width: 0;
  max-height: 115px;
  box-shadow: 0 0 16px rgba(0, 0, 0, 0.05);
  border-radius: 8px;
  cursor: pointer;
  padding: 8px;
  background-color: $white;

  &__image {
    width: 100%;
    height: 100%;
  }
}
</style>
